import React from 'react';
import PropTypes from 'prop-types';
import { isArray } from 'lodash';

import Error from './Error.jsx';

let errors = [];
let components = [];

class ErrorBox extends React.Component {
    UNSAFE_componentWillMount() {
        this.attach();

        // if (__DEV__) {
        this.timeout = setInterval(() => this.attach(), 1000);
        // }
    }

    componentWillUnmount() {
        let index = components.indexOf(this);

        if (index !== -1) {
            components.slice(index, 1);
        }

        clearInterval(this.timeout);
    }

    attach() {
        let index = components.indexOf(this);

        if (index === -1) {
            components.push(this);
        }
    }

    onClose(index) {
        errors.splice(index, 1);

        ErrorBox.updateErrors(errors);
    }

    render() {
        return (
            <ul className={ 'error-box' + (errors.length ? '' : ' error-box--hidden') }>
                {
                    errors.map((message, idx) => (
                        <Error
                            message={ message }
                            key={ idx }
                            onClose={ () => this.onClose(idx) }
                        />
                    ))
                }
            </ul>
        );
    }
}

ErrorBox.addError = function (err) {
    if (!isArray(err)) {
        err = [ err ];
    }

    ErrorBox.updateErrors(
        [].concat(errors).concat(err)
    );
};

ErrorBox.updateErrors = function (errs) {
    errors = errs;
    components.forEach(component => component.forceUpdate());
};

export default ErrorBox;
